import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { REDIRECT_PARAM } from 'constants/config';

export default ({ component: C, props: cProps, ...rest }) =>
  (<Route
    {...rest}
    render={props => (cProps.isAuthenticated ?
      <C {...props} {...cProps} /> :
      <Redirect to={`/login?${REDIRECT_PARAM}=${props.location.pathname}${props.location.search}`} />)
    }
  />);
